import { render, staticRenderFns } from "./PasswordRecoveryForm.vue?vue&type=template&id=1e837976&scoped=true"
import script from "./PasswordRecoveryForm.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e837976",
  null
  
)

export default component.exports